export const enablePromise = () => { };
export const openDatabase = () => Promise.resolve({
    executeSql: () => Promise.resolve([{ rows: { length: 0, item: () => null } }]),
    transaction: (cb) => cb({ executeSql: (s, p, success) => success && success([], { rows: { length: 0 } }) }),
    close: () => Promise.resolve(),
});

const SQLite = {
    enablePromise,
    openDatabase,
};

export default SQLite;
